export { default } from './RemoveShopCodeLink'
